import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedTranslateModule } from '../../../../src/app/utils/sharedTranslateModule';
import { WindowRef } from '../../../../src/app/utils/window';

@Component({
    selector: 'div.dtf-unsubscribe',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatIconModule, MatSortModule
    ],
    templateUrl: './unsubscribe.component.html'
})
export class UnsubscribeComponent {
  usUrl: string;

  constructor( private _window: WindowRef) {  
      this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
  }

  goToHomepage(){
    this._window.nativeWindow.location.href = '/home';
  }

}
